"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _dompurify = _interopRequireDefault(require("dompurify"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ReturnToLoginLink = _ref => {
  let {
    returnToLogin,
    linkText
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "field field-navigate-link"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "control"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "navigate-link-wrapper"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons has-text-link"
  }, "navigate_next"), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "/login.html",
    className: "step-navigation-link",
    onClick: e => returnToLogin(e)
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "navigate-link-text",
    dangerouslySetInnerHTML: {
      __html: _dompurify.default.sanitize(linkText && linkText.length > 0 ? linkText : 'Return to Login')
    }
  })))));
};
ReturnToLoginLink.propTypes = {
  returnToLogin: _propTypes.default.func,
  linkText: _propTypes.default.string
};
var _default = exports.default = ReturnToLoginLink;
//# sourceMappingURL=ReturnToLoginLink.js.map